export default {
      id: "reefer-evaporator-usage",
      viewBox: "0 0 33 22",
      url: __webpack_public_path__ + "img/icons.svg#reefer-evaporator",
      toString: function () {
        return this.url;
      }
    }